import { useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import SEOHead from "@/components/feature/SEOHead";
import ScrollToTop from "@/components/feature/ScrollToTop";
import { allContent, categories } from "@/mocks/content";

const articleBodies: Record<number, { intro: string; sections: { heading: string; content: string }[]; relatedIds: number[] }> = {
  1: {
    intro: "《东京爱情故事》作为日剧史上最具代表性的爱情剧之一，自1991年首播以来便深受全球观众喜爱。2026年重制版采用4K修复技术，对每一帧画面进行了精细的数字化处理，让这部诞生于平成时代的经典作品以全新的面貌呈现在观众面前。",
    sections: [
      {
        heading: "经典重现：4K修复技术详解",
        content: "本次重制采用了业界领先的AI画质增强技术，结合人工逐帧调色，将原有的标清画质提升至4K超高清分辨率。修复团队历时18个月，处理了超过20万帧画面，每一帧都经过色彩校正、噪点去除、细节增强等多道工序，确保在保留原作胶片质感的同时，呈现出更加清晰细腻的视觉效果。",
      },
      {
        heading: "剧情回顾：平成时代的爱情经典",
        content: "故事讲述了从爱媛县来到东京工作的永尾完治，与公司同事赤名莉香之间一段刻骨铭心的爱情故事。莉香的开朗热情与完治的内敛温柔形成了鲜明对比，两人在东京这座繁华都市中经历了相遇、相知、相爱到最终分离的全过程，深刻描绘了都市男女在爱情中的甜蜜与无奈。",
      },
      {
        heading: "演员阵容：传奇组合再聚首",
        content: "铃木保奈美与织田裕二的经典搭档至今无人超越。重制版特别收录了两位主演的最新访谈，他们回顾了当年拍摄的幕后故事，分享了各自对角色和剧情的理解。时隔三十余年，两位演员依然对这部作品充满深情，令人动容。",
      },
      {
        heading: "为什么值得重温",
        content: "东京爱情故事不仅仅是一部爱情剧，它更是一代人的青春记忆。重制版不仅画质得到了全面提升，还新增了导演评论音轨、未公开拍摄花絮等独家内容。无论是老观众重温经典，还是新观众初次接触，都能从中感受到日剧黄金时代的独特魅力。",
      },
    ],
    relatedIds: [6, 12, 15],
  },
  2: {
    intro: `《首尔大作战：极限挑战》是韩国王牌综艺节目的最新一季，本季节目以"极限挑战"为主题，邀请了多位韩国顶级艺人参与，在城市各个角落展开一系列令人捧腹又紧张刺激的游戏对决。`,
    sections: [
      {
        heading: "节目亮点：明星阵容全面升级",
        content: "本季节目邀请了刘在石、李光洙、金钟国等原班人马回归，同时新增了三位当红偶像团体成员作为常驻嘉宾。新老成员之间的化学反应出人意料地精彩，每一期都能碰撞出令人惊喜的火花。节目组在游戏设计上也更加大胆创新，将传统游戏与高科技元素相结合。",
      },
      {
        heading: "精彩看点：爆笑游戏环节",
        content: `本季最受欢迎的游戏环节包括"城市追击战"、"密室逃脱挑战"和"水上极限对决"。在"城市追击战"中，成员们需要在首尔市区完成一系列任务，同时躲避"猎手"的追捕，整个过程紧张刺激又笑料百出。`,
      },
      {
        heading: "制作升级：电影级拍摄水准",
        content: "本季节目在拍摄制作上投入了前所未有的资源，采用了电影级的摄影设备和航拍技术，将综艺节目的视觉呈现提升到了新的高度。特别是在大型户外游戏环节中，多角度、多机位的拍摄让观众仿佛身临其境。",
      },
    ],
    relatedIds: [4, 8, 10],
  },
  3: {
    intro: "《进击的巨人》最终季完结篇为这部横跨十年的现象级动漫作品画上了震撼人心的句号。这部由谏山创原作的史诗级作品，以其宏大的世界观、深刻的人性探讨和惊人的剧情反转，在全球范围内引发了持续的文化现象。",
    sections: [
      {
        heading: "史诗终章：十年的等待与期待",
        content: "从2013年第一季播出至今，《进击的巨人》已经陪伴全球观众走过了整整十年。最终季完结篇以电影级的制作水准，将漫画原作中的经典场景一一还原，每一场战斗都令人热血沸腾，每一个角色的命运都牵动人心。MAPPA工作室倾尽全力，为这部传奇作品献上了最完美的告别。",
      },
      {
        heading: "剧情深度：自由与宿命的终极对决",
        content: "完结篇的核心围绕着艾伦·耶格尔的终极计划展开。当真相一层层揭开，观众们发现这部看似讲述人类与巨人战斗的故事，实则是对战争、自由、种族与人性最深刻的拷问。艾伦的选择令人震惊，却也让人不得不思考：为了自由，究竟可以付出怎样的代价？",
      },
      {
        heading: "视觉盛宴：动画制作的巅峰",
        content: "完结篇在动作场面和视觉呈现上达到了日本TV动画的巅峰水平。尤其是最终决战场景，巨人与人类之间的宏大战争场面，每一帧都堪称艺术品。配乐方面，泽野弘之的经典配乐与全新创作完美融合，将情感张力推向了极致。",
      },
    ],
    relatedIds: [7, 9, 13],
  },
  4: {
    intro: "奉俊昊导演的《寄生虫》荣获第92届奥斯卡最佳影片等四项大奖，创造了非英语电影的历史。此次导演剪辑加长版新增了30分钟此前从未公开的画面，让观众能够更深入地理解这部社会寓言的每一个细节。",
    sections: [
      {
        heading: "奥斯卡传奇：非英语电影的里程碑",
        content: "2019年《寄生虫》在戛纳电影节首映即获金棕榈奖，随后横扫全球各大奖项，最终在奥斯卡颁奖礼上创造了历史——成为首部获得最佳影片的非英语电影。这一成就不仅属于韩国电影，更是全球电影史上的重要里程碑。",
      },
      {
        heading: "导演剪辑版：30分钟未公开画面",
        content: "本次加长版新增的内容包括：金家四口人在半地下室生活的更多日常细节、朴社长一家外出时金家在豪宅中的更多互动场景、以及地下室夫妇的完整背景故事。这些新增画面让每个角色的动机和情感更加丰满立体。",
      },
      {
        heading: "社会寓言：阶层固化的深刻洞察",
        content: `《寄生虫》之所以能够引起全球观众的共鸣，在于它用悬疑惊悚的外壳包裹了一个关于社会阶层固化的普世寓言。金家和朴家之间的"寄生"关系，折射出当代社会中无处不在的贫富差距与阶层壁垒，引人深思。`,
      },
    ],
    relatedIds: [11, 14, 16],
  },
};

const defaultBody = {
  intro: "这是一部精彩的日韩内容作品，为您带来极致的观看体验。无论您是日韩文化的爱好者，还是寻找高质量娱乐内容的观众，这部作品都不容错过。",
  sections: [
    {
      heading: "内容简介",
      content: "本作品汇聚了顶尖的制作团队和演员阵容，以精良的制作水准和引人入胜的故事情节赢得了观众的广泛好评。从画面质感到音效设计，每一个细节都经过精心打磨，力求为观众呈现最佳的观看体验。在aaa日韩平台上，您可以畅享高清流畅的播放体验。",
    },
    {
      heading: "精彩看点",
      content: "本作品在剧情的编排上独具匠心，情节跌宕起伏，人物塑造丰满立体。无论是主角的成长历程，还是配角的故事线，都充满看点。特别是在关键情节的处理上，导演展现了极高的叙事技巧，让人欲罢不能。aaa日韩高清画质让每一个精彩瞬间都纤毫毕现。",
    },
    {
      heading: "观看建议",
      content: "建议在安静的环境中，使用大屏幕设备观看本作品，以获得最佳的沉浸式体验。aaa日韩支持多终端同步播放，您可以在手机、平板、电脑和智能电视上无缝切换，随时随地享受精彩内容。",
    },
  ],
  relatedIds: [1, 2, 3],
};

export default function Article() {
  const { id } = useParams<{ id: string }>();
  const numericId = Number(id);

  const article = allContent.find((item) => item.id === numericId);
  const body = articleBodies[numericId] || defaultBody;
  const categoryInfo = article ? categories.find((c) => c.slug === article.category) : null;
  const relatedContent = useMemo(
    () => allContent.filter((item) => body.relatedIds.includes(item.id) && item.id !== numericId),
    [numericId, body.relatedIds],
  );

  const articleSchema = article
    ? [
        {
          "@context": "https://schema.org",
          "@type": "Article",
          headline: article.title,
          description: article.description || body.intro,
          datePublished: article.updateDate,
          url: `https://www.aaark.com/article/${article.id}`,
          author: {
            "@type": "Organization",
            name: "aaa日韩",
          },
          publisher: {
            "@type": "Organization",
            name: "aaa日韩",
          },
        },
      ]
    : [];

  if (!article) {
    return (
      <>
        <Navbar />
        <div className="min-h-screen pt-20 flex items-center justify-center">
          <p className="text-foreground-600">内容不存在</p>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <SEOHead
        title={`${article.title} - aaa日韩高清在线观看`}
        description={`${article.title}，${body.intro.substring(0, 120)}。正版授权，高清流畅，尽在aaa日韩。`}
        keywords={`${article.title},aaa日韩,日韩高清,正版内容,${categoryInfo?.name || ""}`}
        canonicalUrl={`https://www.aaark.com/article/${article.id}`}
        ogType="article"
        ogImage={article.image}
        schemaJson={articleSchema}
      />
      <ScrollToTop />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-16">
          <Breadcrumb
            items={[
              { label: "首页", to: "/" },
              { label: categoryInfo?.name || "内容", to: categoryInfo ? `/category/${categoryInfo.slug}` : undefined },
              { label: article.title },
            ]}
          />

          <article className="px-4 md:px-6 py-8 max-w-4xl mx-auto">
            {/* Article Header */}
            <div className="mb-8">
              <div className="relative aspect-video rounded-lg overflow-hidden mb-6">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-3 left-3 px-3 py-1 rounded-full text-sm font-medium bg-black/60 text-white">
                  {categoryInfo?.name}
                </div>
              </div>

              <h1 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
                {article.title}
              </h1>

              <div className="flex flex-wrap items-center gap-4 text-sm text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-star-fill text-accent-500"></i>
                  {article.rating}
                </span>
                <span>{article.duration}</span>
                <span>{article.episode}</span>
                <span>更新于 {article.updateDate}</span>
              </div>
            </div>

            {/* Article Body */}
            <div className="prose-custom">
              <p className="text-base text-foreground-700 leading-relaxed mb-6">{body.intro}</p>

              {body.sections.map((section, index) => (
                <div key={index} className="mb-8">
                  <h2 className="text-xl font-semibold text-foreground-950 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
                    {section.heading}
                  </h2>
                  <p className="text-base text-foreground-700 leading-relaxed">{section.content}</p>
                </div>
              ))}
            </div>

            {/* Related Content */}
            {relatedContent.length > 0 && (
              <div className="mt-12 pt-8 border-t border-background-200/60">
                <h3 className="text-lg font-semibold text-foreground-950 mb-5">
                  相关推荐
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                  {relatedContent.map((item) => (
                    <Link
                      key={item.id}
                      to={`/article/${item.id}`}
                      className="group rounded-lg overflow-hidden bg-background-100 hover:bg-background-200/70 transition-all cursor-pointer"
                    >
                      <div className="relative aspect-video overflow-hidden">
                        <img
                          src={item.image}
                          alt={item.title}
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        />
                        <div className="absolute top-2 right-2 px-2 py-0.5 rounded text-xs font-medium bg-accent-500 text-background-50">
                          {item.rating}
                        </div>
                      </div>
                      <div className="p-3">
                        <h4 className="text-sm font-medium text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1">
                          {item.title}
                        </h4>
                        <p className="text-xs text-foreground-400 mt-1">{item.updateDate}</p>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            )}

            {/* Navigation */}
            <div className="mt-10 flex items-center justify-between">
              <Link
                to={categoryInfo ? `/category/${categoryInfo.slug}` : "/"}
                className="flex items-center gap-2 text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-left-line"></i>
                返回{categoryInfo?.name || "列表"}
              </Link>
              <Link
                to="/"
                className="flex items-center gap-2 text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
              >
                回到首页
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </article>
        </main>

        <Footer />
      </div>
    </>
  );
}